import { mediaStackSourceUrl } from "../index";
import { blocker } from "../index";



export async function getMediaStack() {
    blocker.classList.add('show')
    const sourceUrl = mediaStackSourceUrl;
    const mediaStackResponse = await fetch(sourceUrl)

    try {
        let mediaStackJson = await mediaStackResponse.json();
        mediaStackJson = mediaStackJson.data;
        if (mediaStackJson === "No results") {
            let errorMessage = document.createElement("div");
            errorMessage.classList.add("story", "source");
            errorMessage.innerHTML = "No results from MediaStack... please change your filters and try again"
            leftColumn.appendChild(errorMessage.cloneNode(true));
            centerColumn.appendChild(errorMessage.cloneNode(true));
            rightColumn.appendChild(errorMessage.cloneNode(true));
            return console.log('no mediastack results')
        } else {
            if (mediaStackJson) {
                mediaStackJson.reverse();
            }
            for (let i in mediaStackJson) {
                let title = mediaStackJson[i].title;
                let description = mediaStackJson[i].description;
                description = description.substring(0, 500) + ' ...';
                let url = mediaStackJson[i].url;
                let incomingSource = mediaStackJson[i].source;
                let formattedSource = "Source: " + incomingSource;
                let time = mediaStackJson[i].published_at;
                let author = "Author: " + mediaStackJson[i].author;

                let newsStory = document.createElement("li");
                let storyTitle = document.createElement("label");
                let titleCheckbox = document.createElement("input");
                titleCheckbox.setAttribute('type', 'checkbox');
                let titleSpan = document.createElement("span");
                titleSpan.append(title);
                let anchor = document.createElement("a");
                let descriptionDiv = document.createElement("div");
                let sourceDiv = document.createElement("div");
                let authorDiv = document.createElement("div");
                let timeDiv = document.createElement("div");

                anchor.setAttribute('href', url);
                anchor.setAttribute('target', "_blank");
                descriptionDiv.append(description)
                anchor.append(descriptionDiv);
                sourceDiv.append(formattedSource);
                authorDiv.append(author);
                timeDiv.append(new Date(time));
                storyTitle.append(titleCheckbox, titleSpan, anchor);

                storyTitle.classList.add('storyTitle');
                descriptionDiv.classList.add('description');
                sourceDiv.classList.add('source');
                authorDiv.classList.add('author');
                timeDiv.classList.add('time');

                newsStory.classList.add('story');
                newsStory.append(storyTitle)
                newsStory.append(sourceDiv)
                newsStory.append(authorDiv)
                newsStory.append(timeDiv)

                if (mediaStackJson[i].source.match(/CNN/)) {
                    switch (localStorage.getItem('cnnBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/alternet/)) {
                    switch (localStorage.getItem('alternetBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/TechCrunch/)) {
                    switch (localStorage.getItem('techCrunchBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/Times/)) {
                    switch (localStorage.getItem('nyTimesBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/Seeking/g)) {
                    switch (localStorage.getItem('seekingAlphaBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/TIME/)) {
                    switch (localStorage.getItem('timeBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/independent|Independent/)) {
                    switch (localStorage.getItem('independentBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/Guardian/)) {
                    switch (localStorage.getItem('guardianBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/wired/)) {
                    switch (localStorage.getItem('wiredBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/MarketWatch/)) {
                    switch (localStorage.getItem('marketWatchBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/BBC/)) {
                    switch (localStorage.getItem('bbcBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/politico/)) {
                    switch (localStorage.getItem('politicoBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/Forbes/)) {
                    switch (localStorage.getItem('forbesBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/NBC/)) {
                    switch (localStorage.getItem('nbcBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/dailymail/)) {
                    switch (localStorage.getItem('dailyMailBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/nationalreview/)) {
                    switch (localStorage.getItem('nationalReviewBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
                if (mediaStackJson[i].source.match(/FOX/)) {
                    switch (localStorage.getItem('foxNewsBias')) {
                        case 'left':
                            leftColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'center':
                            centerColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                        case 'right':
                            rightColumn.insertAdjacentElement("afterBegin", newsStory);
                            break;
                    }
                }
            }
        }

    } catch (error) {
        console.info(error)
    }

}
